import React, { Component } from 'react'
import { Drawer, Button } from 'hljd'
import Questionnaire from './Questionnaire'
import get from 'lodash/get'
import { observer } from 'mobx-react'
import style from './style.module.less'

@observer
export default class extends Component {
  //判断是否存在下一条数据
  doHasNext = (budgetList = [], current_budget) => {
    const index = budgetList.findIndex(
      item =>
        item.id == current_budget.property_id ||
        item.property_id == current_budget.property_id
    )
    return {
      hasPrev: index != 0,
      hasNext: index < budgetList.length - 1,
      index
    }
  }

  toggleQuestionnaire = (current, is_switch) => {
    const {
      questionDrawerStore: { toggleQuestionnaire, getInfo }
    } = this.props.store
    toggleQuestionnaire(current, is_switch)
    getInfo()
  }

  render() {
    const {
      questionDrawerStore: {
        question_visibility,
        toggleQuestionnaire,
        current_budget
      },
      budgetList
    } = this.props.store

    const checkField = this.doHasNext(budgetList, current_budget)
    //budgetList列表开始用id，后面用property_id，待统一
    const field_id = budgetList[0] && budgetList[0].id ? 'id' : 'property_id'

    return (
      <Drawer
        title={`${current_budget.title}`}
        width={748}
        closable={false}
        onClose={() => toggleQuestionnaire()}
        visible={question_visibility}
      >
        <Questionnaire />
        <div className={style['drawer-footer']}>
          {checkField.hasPrev && (
            <Button
              style={{ position: 'absolute', left: '10px' }}
              onClick={() =>
                this.toggleQuestionnaire(
                  get(budgetList, [`${checkField.index - 1}`, field_id], ''),
                  true
                )
              }
            >
              上一个
            </Button>
          )}
          <Button onClick={() => toggleQuestionnaire()}>取消</Button>
          <Button onClick={this.toggleQuestionnaire}>仅保存</Button>
          {checkField.hasNext && (
            <Button
              type="primary"
              onClick={() =>
                this.toggleQuestionnaire(
                  get(budgetList, [`${checkField.index + 1}`, field_id], ''),
                  true
                )
              }
            >
              保存，下一个
            </Button>
          )}
        </div>
      </Drawer>
    )
  }
}
